import { render, staticRenderFns } from "./AssetTab.vue?vue&type=template&id=06cdfe3a&"
import script from "./AssetTab.vue?vue&type=script&lang=js&"
export * from "./AssetTab.vue?vue&type=script&lang=js&"
import style0 from "./AssetTab.vue?vue&type=style&index=0&id=06cdfe3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports